export default __webpack_public_path__ + "static/media/fa-brands-400.5818bbd0.ttf";